import { createRouter, createWebHistory } from 'vue-router';
import HomePageView from '../views/HomePageView.vue';
import ResultPageView from '../views/ResultPageView.vue';
import RiskDetailView from '../views/RiskDetailView.vue';
import ResultDetailView from '../views/ResultDetailView.vue';
import FamilyHistoryView from '../views/FamilyHistoryView.vue';
import ImunizationView from '../views/ImunizationView.vue';
import SkilasDetailView from '../views/SkilasDetailView.vue';
import AksDetailView from '../views/AksDetailView.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import FAQView from '../views/FAQView.vue';
import HomePageCmsView from '../views/HomePageCmsView.vue';
import MainNavigation from '../components/Navigation.vue';

export const routes = [
  {
    path: '/error',
    name: '401',
    components: {
      default: () => import(/* webpackChunkName: "Error" */ '../views/401Page.vue'),
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Error',
        back: false,
        // size: 20,
        // name: false,
      },
    },
    meta: { requireAuth: false },
  },
  {
    path: '/screening-result',
    name: 'Homepage',
    components: {
      default: HomePageView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Rekap detail pemeriksaan',
        back: false,
        size: 16,
        name: true,
      },
    },
    meta: { requireAuth: false },
  },
  {
    path: '/result',
    name: 'ResultPage',
    components: {
      default: ResultPageView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Hasil Pemeriksaan',
        back: false,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: true },
  },
  {
    path: '/risk',
    name: 'RiskDetail',
    components: {
      default: RiskDetailView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Resiko Kehamilan',
        back: true,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: true },
  },
  {
    path: '/detail-result',
    name: 'ResultDetail',
    components: {
      default: ResultDetailView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Detail Pemeriksaan',
        back: true,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: true },
  },
  {
    path: '/family-history',
    name: 'FamilyHistory',
    components: {
      default: FamilyHistoryView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Riwayat Keluarga',
        back: true,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: true },
  },
  {
    path: '/imunization',
    name: 'Imunization',
    components: {
      default: ImunizationView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Riwayat Imunisasi',
        back: true,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: true },
  },
  {
    path: '/skilas',
    name: 'SkilasDetail',
    components: {
      default: SkilasDetailView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'SKILAS',
        back: true,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: true },
  },
  {
    path: '/aks',
    name: 'AksDetail',
    components: {
      default: AksDetailView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'AKS',
        back: true,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: true },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    components: {
      default: PrivacyPolicyView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Kebijakan Privasi',
        back: false,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: false },
  },
  {
    path: '/faq',
    name: 'FAQ',
    components: {
      default: FAQView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Frequently Asked Questions',
        back: false,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: false },
  },
  {
    path: '/screening-result-cms',
    name: 'HomepageCms',
    components: {
      default: HomePageCmsView,
      navbar: MainNavigation,
    },
    props: {
      navbar: {
        text: 'Loading...',
        back: false,
        size: 20,
        name: false,
      },
    },
    meta: { requireAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from) {
    if (to !== from) {
      return { top: 0 }; // always scroll to top
    }
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requireAuth) {
    if (to.query.token) {
      const storage = localStorage.getItem(encodeURIComponent(to.query.token));
      if (storage) {
        next();
      } else {
        next({
          name: 'Homepage',
          query: to.query,
        });
      }
    } else {
      next({ name: '401' });
    }
  } else {
    next();
  }
});
export default router;
